import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actionCreators from "../actions/actionCreators.js";


import MultiPrintPublic from "../components/MultiPrintPublic";


function mapStateToProps(state){
	//console.log("Connecting state", state.series);
	return {
		lang: state.data.lang,
		auth: state.data.auth
	}
}

function mapDispatchToProps(dispatch){
	return bindActionCreators(actionCreators, dispatch);
}


const MultiPrintPublicContainer = connect(mapStateToProps, mapDispatchToProps)(MultiPrintPublic);

export default MultiPrintPublicContainer;


// WEBPACK FOOTER //
// ./src/containers/MultiPrintPublicContainer.js